var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ContextMenu from 'src/components/ContextMenu/ContextMenu';
import { getCellProps } from 'src/types';
import Vue from 'vue';
import { omit } from 'lodash';
import Store from 'src/store';
import { getRowClasses, getRowStyles, getTdClasses, getTdStyles, getCellDivStyles, getCellDivClasses, getCellContentClasses } from '../utils/gettersOfCalculatedStylesAndClasses';
import RecordCard from '../RecordCard/RecordCard.vue';
import createRecords from 'src/utils/entityOperations/createRecords';
import callRefFunc from 'src/utils/callRefFunc';
import getCurrentMode from 'src/utils/currentMode/getCurrentMode';
import InfoIcon from 'src/components/UtilityComponents/InfoIcon.vue';
import { actingUserHasControlledAction } from 'src/utils/actingUser';
import { invokeOrFalse, invokeOrIdentity } from 'src/utils';
import GenericDialog from 'src/components/GenericDialog/GenericDialog';
import getColumns from 'src/utils/entityOperations/columns/getColumns';
import setCurrentMode from 'src/utils/currentMode/setCurrentMode';
import getEntityDefaultRecordCardComponent from 'src/utils/entityOperations/propertyGetters/getEntityDefaultRecordCardComponent';
// getEntityDefaultRecordCreateComponent is surprisingly in Index.vue
import { goToPreviousMode } from 'src/store/mode';
import Tooltip from './components/Tooltip.vue';
import isDevelopmentEnvironment from 'src/utils/developer/isDevEnvironment';
import getRowBeingDragged from 'src/utils/entityOperations/getRowBeingDragged';
import setRowBeingDragged from 'src/utils/entityOperations/setRowBeingDragged';
import getter from 'src/utils/entityOperations/getter';
import Button from 'src/components/Button/Button';
import isDefined from 'src/utils/filterFunctions/isDefined';
import isNotDefined from 'src/utils/filterFunctions/isNotDefined';
import not from 'src/utils/logical/not';
export default Vue.extend({
    name: 'BodySlot',
    components: { ContextMenu, InfoIcon, Tooltip, Button },
    props: {
        props: { type: Object, required: true },
        columnsFilteredAndEnriched: { type: Array },
        cellClickHandler: { type: Function },
        getCellPropsObject: { type: Function },
        borderLeftIfNeededWhileMovingAnotherColumn: { type: Function },
        localEntityName: { type: String },
        createRecord: { type: Function },
        getValueFromEnrichedData: { type: Function },
        getDisplayValueFromEnrichedData: { type: Function },
        toggleSelection: { type: Function },
        cellIsEditable: { type: Function },
        handleCellChange: { type: Function },
        selectedIds: { type: Array },
        tryToOpenValueSelectorDialog: { type: Function },
        loading: { type: Boolean },
        showInnerLoadingWhenLoadingPassedThroughProps: { type: Boolean },
        ctx: { type: Object },
        data: { type: Array },
        cellContentStyles: { type: Function },
        updatingRecordsIsEnabled: { type: Boolean },
        deleteRow: { type: Function },
        editRecord: { type: Function },
        columnsLocalCopy: { type: Array },
        fillInDefaultValuesOfRecord: { type: Function },
        selectOnlyThisFilterItem: { type: Function },
        filterOutThisFilterItem: { type: Function },
        setDialogComponentPlaceHolder: { type: Function },
        openDialog: { type: Function },
        fetchData: { type: Function }
    },
    data() {
        return {
            dialogComponentPlaceHolder: null,
            dialogComponentPlaceHolderProps: null,
            cellTextIsInEditingMode: false
        };
    },
    computed: {
        rowBeingDragged: {
            get() { return getRowBeingDragged(this.localEntityName); },
            set(value) { if (this.localEntityName)
                setRowBeingDragged(this.localEntityName, value); }
        },
        rowDragIsInProgress() { return Boolean(this.rowBeingDragged); },
        ids() { return this.data.map((r) => r.id); },
        inlineEditColumns() { return this.columnsFilteredAndEnriched.filter((col) => col.inlineEdit === true).map((col) => String(col.name)); },
        currentMode() { return getCurrentMode(); }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('keydown', e => {
                if (e.key === 'Escape') {
                    if (this.currentMode.name === 'generic-create-new-record' || this.currentMode.component === RecordCard)
                        goToPreviousMode();
                    this.cellTextIsInEditingMode = false;
                }
            });
        });
    },
    methods: {
        actingUserHasControlledAction,
        getRowClasses,
        getRowStyles,
        getTdClasses,
        getCellDivStyles,
        getCellDivClasses,
        getCellContentClasses,
        callRefFunc,
        invokeOrFalse,
        invokeOrIdentity,
        getRowClasses2(props, ctx) {
            const res = getRowClasses(props, ctx);
            if (this.rowDragIsInProgress && this.rowBeingDragged) {
                const idOfRowBeingDragged = this.rowBeingDragged.id;
                const rowId = props.row.id;
                res.push('row-drag-is-in-progress');
                if (idOfRowBeingDragged === rowId) {
                    res.push('row-being-dragged');
                }
                else {
                    const rowIsHigherThanTheRowBeingDragged = this.ids.indexOf(idOfRowBeingDragged) < this.ids.indexOf(rowId);
                    if (rowIsHigherThanTheRowBeingDragged) {
                        res.push('row-being-dragged-is-higher');
                    }
                    else {
                        res.push('row-being-dragged-is-lower');
                    }
                }
            }
            return res.join(' ');
        },
        // region: RowDrag
        startRowDrag(e, row) {
            e.stopImmediatePropagation();
            // console.log('startRowDrag')
            // console.log('row =', row)
            this.rowBeingDragged = row;
        },
        endRowDrag(e, row) {
            var _a;
            if (!this.rowBeingDragged || ((_a = this.rowBeingDragged) === null || _a === void 0 ? void 0 : _a.id) === row.id)
                return;
            e.stopImmediatePropagation();
            // console.log('endRowDrag')
            const rowDragCompletionCallback = getter(this.localEntityName, 'rowDragCompletionCallback');
            if (rowDragCompletionCallback) {
                rowDragCompletionCallback(this.rowBeingDragged, row);
            }
            // console.log('row =', row)
            this.rowBeingDragged = null;
        },
        // endregion
        isTotalsRow(cellProps) { return cellProps.row.isTotalsRow || cellProps.row.isGrandTotalsRow; },
        openViewCodeDialog(params) {
            this.$emit('open-view-code-dialog', params);
        },
        getDropdownSelectorOptions(cellProps) {
            const { col, row } = cellProps;
            const options = col.dropdownSelectorOptions;
            const result = options ? (typeof options === 'function' ? options({ row, col }) : options) : [];
            return result;
        },
        getClassShowOnRowHover(cellProps) {
            const { col } = cellProps;
            let showRegardlessOfRowHover = false;
            if (typeof col.showRegardlessOfRowHover === 'boolean') {
                showRegardlessOfRowHover = col.showRegardlessOfRowHover;
            }
            else if (typeof col.showRegardlessOfRowHover === 'function') {
                showRegardlessOfRowHover = col.showRegardlessOfRowHover(cellProps);
            }
            return showRegardlessOfRowHover ? '' : 'show-on-row-hover';
        },
        getClassesForRowButton(cellProps) {
            return 'row-button ' + this.getClassShowOnRowHover(cellProps);
        },
        getInfoIconContent(props, col) {
            const value = col.addInfoIconWithContentOfDescriptionField;
            if (value === undefined)
                return null;
            let field = '';
            if (typeof value === 'boolean') {
                field = 'description';
            }
            else if (typeof value === 'string') {
                field = value;
            }
            else if (typeof value === 'function') {
                if (typeof value === 'function')
                    field = value(Object.assign(Object.assign({}, props), { col })); // i.e., this is a kind of valuegetter in this role or type
            }
            return props.row[field];
        },
        getTableComponentProps(props, col) {
            var _a, _b;
            const filtersProp = invokeOrIdentity((_a = col.tableProps) === null || _a === void 0 ? void 0 : _a.filtersProp, Object.assign(Object.assign({}, props), { col }));
            const initialDataProp = invokeOrIdentity((_b = col.tableProps) === null || _b === void 0 ? void 0 : _b.initialDataProp, Object.assign(Object.assign({}, props), { col }));
            const res = Object.assign(Object.assign({}, (col.tableProps || {})), { parentRecordProp: props.row, filtersProp });
            if (initialDataProp)
                res.initialDataProp = initialDataProp; // this strange construction handles case when invokeOrFalse returns false into intialDataProp
            return res;
        },
        routeToCellClickHandler(props, col, e) {
            const cellProps = this.getCellPropsObject(props, col);
            this.$emit('row-click', { props, col, e });
            if (col.cellClickHandler && !this.isTotalsRow(cellProps)) {
                col.cellClickHandler(cellProps, this.ctx, e);
            }
            else {
                this.cellClickHandler(cellProps, e);
            }
        },
        cellDivStyles(col, props) {
            let res = getCellDivStyles(col, props, this);
            res = Object.assign(Object.assign({}, res), { 'minHeight': '18px' });
            return res;
        },
        tdStyles(col, props) {
            let res = getTdStyles(col, props) || {};
            res = Object.assign(Object.assign({}, res), (this.borderLeftIfNeededWhileMovingAnotherColumn(col) || {}));
            return res;
        },
        isPopupEdit(cellProps) {
            return (not(this.isTotalsRow(cellProps)) &&
                this.updatingRecordsIsEnabled &&
                this.cellIsEditable(cellProps) &&
                isNotDefined(cellProps.col.cellClickHandler) &&
                invokeOrIdentity(cellProps.col.inlineEdit, cellProps)) || false;
        },
        getTooltipContent(cellProps) {
            const { col, row } = cellProps;
            if (col.supressAutomaticTooltip)
                return null;
            if (this.isTotalsRow(cellProps))
                return null;
            if (col.isCode)
                return null;
            if (col.isCheckbox)
                return null;
            if (col.component)
                return null;
            if (col.tooltipContent) {
                if (typeof col.tooltipContent === 'string' && col.tooltipContent !== '')
                    return col.tooltipContent;
                if (typeof col.tooltipContent === 'function' && col.tooltipContent(cellProps) !== '')
                    return col.tooltipContent(cellProps);
            }
            if (col.isNumeric)
                return null;
            const res = String(this.getDisplayValueFromEnrichedData(col, row));
            return res === '' ? null : res;
        },
        handleCellFocusMovement(e, props, col, direction) {
            if (e.code === 'Enter' && e.ctrlKey) {
                this.cellTextIsInEditingMode = false;
                direction = 'none';
            }
            if (this.cellTextIsInEditingMode)
                return;
            if (e.ctrlKey && ['left', 'right'].includes(direction)) {
                // do nothing
            }
            else {
                e.preventDefault();
                e.stopPropagation();
                this.handleCellChange(e, this.getCellPropsObject(props, col));
                this.moveInlineEditFocus(e, col.name, props.row.id, direction);
            }
        },
        moveInlineEditFocus(e, curColName, id, direction) {
            if (e.shiftKey) {
                if (direction === 'right')
                    direction = 'left';
                if (direction === 'down')
                    direction = 'up';
            }
            callRefFunc(this, curColName + String(id), 'hide');
            if (['right', 'left'].includes(direction)) {
                const shift = (direction === 'right') ? 1 : -1;
                let nextColName = this.inlineEditColumns[this.inlineEditColumns.indexOf(curColName) + shift];
                if (nextColName === undefined) {
                    const nextId = this.ids[this.ids.indexOf(id) + shift];
                    if (nextId === undefined)
                        return;
                    nextColName = (direction === 'right') ? this.inlineEditColumns[0] : this.inlineEditColumns[this.inlineEditColumns.length - 1];
                    callRefFunc(this, nextColName + nextId, 'show');
                }
                else {
                    callRefFunc(this, nextColName + id, 'show');
                }
            }
            else if (['up', 'down'].includes(direction)) {
                const shift = (direction === 'down') ? 1 : -1;
                const nextId = this.ids[this.ids.indexOf(id) + shift];
                if (nextId === undefined)
                    return;
                callRefFunc(this, curColName + nextId, 'show');
            }
        },
        rowIsSelected(id) {
            return this.selectedIds.includes(id);
        },
        getToggleColumnProps(cellProps) {
            const col = cellProps.col;
            return Object.assign({ color: typeof col.toggleColor === 'function' ? col.toggleColor(cellProps) : col.toggleColor, size: 'sm' }, (typeof col.toggleProps === 'function' ? col.toggleProps(cellProps) : col.toggleProps));
        },
        getColComponentProps(cellProps) {
            const { col, row } = cellProps;
            if (col.componentProps) {
                return invokeOrIdentity(col.componentProps, col, row, this);
            }
            else if (col.componentProps2) {
                return invokeOrIdentity(col.componentProps2, getCellProps({ col, row }));
            }
        },
        setAsCurrent(id) { Store.commit(this.localEntityName + '/SET_CURRENT', id); },
        viewRecord(e, id) {
            e.stopPropagation();
            this.$emit('exit-full-screen');
            const entityDefaultRecordCard = getEntityDefaultRecordCardComponent(this.localEntityName);
            const genericRecordCard = RecordCard;
            const componentToUse = entityDefaultRecordCard || genericRecordCard;
            setCurrentMode({
                component: componentToUse,
                componentProps: {
                    // not everything may be used by component but something will
                    modeProp: 'viewRecord',
                    localEntityNameProp: this.localEntityName,
                    idProp: id,
                    recordProp: this.data.find((r) => r.id === id)
                }
            });
        },
        handleRowMenuItemClick(e, cellProps, menuItem) {
            if (menuItem.clickHandler)
                menuItem.clickHandler(cellProps, this, e); // 'this' is passed as context ctx
            this.routeRowMenuShortcut(menuItem.name, cellProps, e);
        },
        routeRowMenuShortcut(miName, cellProps, e) {
            const { row } = cellProps;
            if (miName === 'copy_create')
                this.copyCreateRecord(e, row);
            if (miName === 'add_comment')
                this.openAddCommentDialog(e, row);
            if (miName === 'create')
                this.createRecord();
            if (['del', 'edit', 'view'].includes(miName)) {
                const id = this.getValueFromEnrichedData({ field: 'id', name: 'id' }, row);
                if (miName === 'del')
                    this.deleteRow(e, id);
                if (miName === 'edit')
                    this.editRecord(e, id);
                if (miName === 'view')
                    this.viewRecord(e, id);
            }
        },
        copyCreateRecord(e, row) {
            return __awaiter(this, void 0, void 0, function* () {
                e.stopPropagation();
                const fieldsToOmit = this.columnsLocalCopy.filter(col => col.doNotIncludeIntoCopiedRecord).map(col => col.field);
                const rowToCopy = omit(row, fieldsToOmit);
                this.fillInDefaultValuesOfRecord(rowToCopy);
                const insertNewRecordAtPosition = this.data.findIndex((r) => r.id === rowToCopy.id);
                const response = yield createRecords(this.localEntityName, [Object.assign(Object.assign({}, rowToCopy), { insertNewRecordAtPosition })]);
                const data = response.data || response;
                if (data)
                    this.$q.notify({ message: 'Record has been created', type: 'positive', progress: true });
                if (Array.isArray(data)) {
                    return data[0];
                }
                else {
                    return data;
                }
            });
        },
        openAddCommentDialog(e, row) {
            const component = GenericDialog;
            const componentProps = {
                recordCardProps: {
                    modeProp: 'createRecord',
                    localEntityNameProp: 'comments.comments',
                    columnsProp: getColumns('comments.comments'),
                    title: 'Add comment',
                    recordProp: { commentable_entity: this.localEntityName, commentable_id: row.id }
                },
                cardProps: {
                    hideFooter: true
                },
                executeAfterDialogCloseProp: this.fetchData
            };
            this.openDialog(component, componentProps);
        },
        isDisabled(cellProps) {
            const col = cellProps.col;
            if (typeof col.isDisabled === 'function')
                return col.isDisabled(cellProps);
            return Boolean(col.isDisabled);
        },
        renderColumnAsButton(cellProps) {
            if (this.isTotalsRow(cellProps))
                return false;
            const { col } = cellProps;
            return (col.type === 'button') || invokeOrIdentity(col.isButton, cellProps) || false;
        },
        renderColumnAsIcon(cellProps) {
            if (this.isTotalsRow(cellProps))
                return false;
            const { col } = cellProps;
            return (col.type === 'icon') || invokeOrIdentity(col.isIcon, cellProps) || false;
        },
        getButtonColumnProps(cellProps) {
            const col = cellProps.col;
            return Object.assign({ label: this.getButtonLabel(cellProps), dense: true, round: true, flat: true, size: '10px' }, (typeof col.buttonProps === 'function' ? col.buttonProps(cellProps) : col.buttonProps));
        },
        getColumnIcon(cellProps) {
            const col = cellProps.col;
            return (typeof col.icon === 'function') ? col.icon(cellProps) : col.icon;
        },
        getButtonLabel(cellProps) {
            const col = cellProps.col;
            const res = (typeof col.buttonLabel === 'function') ? col.buttonLabel(cellProps) : (col.buttonLabel || '');
            return res;
        },
        cellContentIsHidden(cellProps) {
            const col = cellProps.col;
            if (isDefined(col.cellContentIsHidden))
                return invokeOrIdentity(col.cellContentIsHidden, cellProps) || false;
            if (isDefined(col.cellContentIsShown))
                return invokeOrIdentity(col.cellContentIsShown, cellProps) || false;
            return false;
        },
        renderColumnAsRowMenu(cellProps) {
            const { col } = cellProps;
            return col.type === 'row_menu' &&
                !this.isTotalsRow(cellProps) &&
                Boolean(col.rowMenuItems && col.rowMenuItems.find((mi) => (!mi.menuItemIsShown || mi.menuItemIsShown(cellProps))));
        },
        getCellLeftClickMenu(cellProps) {
            const { col } = cellProps;
            const menu = col === null || col === void 0 ? void 0 : col.cellLeftClickMenu;
            if (!menu) {
                return null;
            }
            else if (typeof menu === 'function') {
                return menu(cellProps);
            }
            else {
                return menu;
            }
        },
        getCellRightClickMenu(cellProps) {
            const { col } = cellProps;
            const menu = col === null || col === void 0 ? void 0 : col.cellRightClickMenu;
            if (!menu) {
                return null;
            }
            else if (typeof menu === 'function') {
                return menu(cellProps);
            }
            else {
                return menu;
            }
        },
        cellHasContextMenu(cellProps) {
            const { col } = cellProps;
            if (col.cellButton || col.type === 'button')
                return false;
            return this.cellValueFilterIsEnabled(cellProps.col) || this.rowHasRowMenu(cellProps.row) || this.getCellRightClickMenu(cellProps) !== undefined || false;
        },
        rowHasRowMenu(row) {
            return this.columnsFilteredAndEnriched.some(col => this.renderColumnAsRowMenu({ row, col }));
        },
        cellValueFilterIsEnabled(col) {
            const includedFilterTypes = ['selectedValuesFilter', 'dateFilters', 'numberFilters', 'textFilters'];
            return (col.uiFilterTypes && col.uiFilterTypes.find((r) => includedFilterTypes.includes(r)) &&
                !col.isTable &&
                !col.isArray &&
                this.data.length > 1) || false;
        },
        getCellContextMenuProps(cellProps) {
            var _a, _b;
            const { col, row } = cellProps;
            if (col === undefined)
                return;
            let menuItems = [];
            const displayValue = String(this.getDisplayValueFromEnrichedData(col, row));
            const value = String(this.getValueFromEnrichedData(col, row));
            menuItems = (displayValue !== value) ? [
                { label: 'Copy cell\'s display value', icon: 'mdi-content-copy', clickHandler: () => navigator.clipboard.writeText(displayValue) },
                { label: 'Copy cell\'s value', icon: 'mdi-content-copy', clickHandler: () => navigator.clipboard.writeText(value) },
                { isSeparator: true }
            ] : [
                { label: 'Copy cell\'s value', icon: 'mdi-content-copy', clickHandler: () => navigator.clipboard.writeText(value) },
                { isSeparator: true }
            ];
            if (this.cellValueFilterIsEnabled(cellProps.col)) {
                menuItems.push({ label: 'Filter by the cell\'s value', icon: 'mdi-filter-outline', clickHandler: () => this.selectOnlyThisFilterItem(col, this.getValueFromEnrichedData(col, row)) });
                menuItems.push({ label: 'Filter out the cell\'s value', icon: 'mdi-filter-minus-outline', clickHandler: () => this.filterOutThisFilterItem(col, this.getValueFromEnrichedData(col, row)) });
            }
            if (isDevelopmentEnvironment()) {
                menuItems.push({ isSeparator: true });
                menuItems.push({
                    label: 'Show cellProps',
                    icon: 'mdi-code-tags',
                    clickHandler: () => this.openViewCodeDialog({
                        code: cellProps,
                        codeLanguage: 'JSON'
                    })
                });
            }
            if (this.rowHasRowMenu(row)) {
                if (menuItems.length > 0)
                    menuItems.push({ isSeparator: true });
                const rowMenuItems = (_a = this.columnsFilteredAndEnriched.find(col => col.type === 'row_menu')) === null || _a === void 0 ? void 0 : _a.rowMenuItems;
                if (rowMenuItems && rowMenuItems.length > 0) {
                    const rowMenuItemsConvertedToContextMenuItems = rowMenuItems
                        .filter(mi => (mi.menuItemIsShown === undefined || mi.menuItemIsShown(cellProps)) &&
                        (mi.needOneOfControlledActions === undefined || actingUserHasControlledAction(mi.needOneOfControlledActions)) &&
                        (typeof mi.clickHandler === 'function') // this eliminiates legacy menu items that rely on handling of click using value of name attribute of menu item
                    )
                        .map((mi) => {
                        return {
                            label: mi.label,
                            icon: mi.icon,
                            clickHandler: (cellProps, ctx, e) => { if (typeof mi.clickHandler === 'function') {
                                mi.clickHandler(cellProps, this, e);
                            } },
                            component: mi.component,
                            componentProps: () => { if (typeof mi.componentProps === 'function') {
                                mi.componentProps(col, row, this);
                            } }
                        };
                    });
                    menuItems = [
                        ...menuItems,
                        ...rowMenuItemsConvertedToContextMenuItems
                    ];
                }
            }
            const rowMenuItemShortcuts = (_b = this.columnsFilteredAndEnriched.find(col => col.type === 'row_menu')) === null || _b === void 0 ? void 0 : _b.menuItemShortcuts;
            if (rowMenuItemShortcuts && rowMenuItemShortcuts.length > 0) {
                for (const rowMenuItemShortcut of rowMenuItemShortcuts) {
                    const miName = rowMenuItemShortcut;
                    if (miName === 'add_comment') {
                        menuItems.push({ label: 'Add comment', icon: 'mdi-comment-plus-outline', clickHandler: (cellProps, ctx, e) => this.openAddCommentDialog(e, cellProps.row) });
                    }
                    else if (miName === 'copy_create') {
                        menuItems.push({ label: 'Copy record', icon: 'mdi-content-copy', clickHandler: (cellProps, ctx, e) => this.copyCreateRecord(e, cellProps.row) });
                    }
                    else if (miName === 'create') {
                        menuItems.push({ label: 'Create record', icon: 'mdi-plus', clickHandler: (cellProps, ctx, e) => this.createRecord() });
                    }
                    else if (miName === 'delete') {
                        menuItems.push({ label: 'Delete record', icon: 'mdi-trash-can-outline', clickHandler: (cellProps, ctx, e) => this.deleteRow(e, cellProps.row.id) });
                    }
                    else if (miName === 'edit') {
                        menuItems.push({ label: 'Edit record', icon: 'mdi-pencil-box-outline', clickHandler: (cellProps, ctx, e) => this.editRecord(e, cellProps.row.id) });
                    }
                    else if (miName === 'view') {
                        menuItems.push({ label: 'View record', icon: 'mdi-eye', clickHandler: (cellProps, ctx, e) => this.viewRecord(e, cellProps.row.id) });
                    }
                }
            }
            const cellRightClickMenuItems = this.getCellRightClickMenu(cellProps) || [];
            if (cellRightClickMenuItems.length > 0) {
                menuItems.push({ isSeparator: true });
                menuItems.push(...cellRightClickMenuItems); // TODO:
            }
            const contextMenuProps = {
                menuItems,
                originCellProps: cellProps,
                activateWithLeftClick: false,
                objectProp: row,
                qMenuPropsProp: { cover: true, anchor: 'center middle' }
            };
            return contextMenuProps;
        }
    }
});
